import { Footer, Header } from "@bodhistreams/ui";
import { Layout, theme } from "antd";

const { useToken } = theme;

const PageLayout = ({ children, fullWidthContent }) => {
	const { token } = useToken();
	return (
		<Layout
			style={{
				minHeight: "100vh",
				display: "flex",
				flexDirection: "column",
				background: token.colorBgLayout,
				position: "relative",
				margin: 0,
				padding: 0,
			}}
		>
			{/* Position the header absolutely so it overlays the content */}
			<div
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					zIndex: 1000,
				}}
			>
				<Header />
			</div>

			<Layout.Content
				style={{
					flex: "1 0 auto",
					display: "flex",
					flexDirection: "column",
					padding: 0,
					overflowX: "clip",
				}}
			>
				{fullWidthContent}
				<div
					style={{
						maxWidth: "1800px",
						width: "100%",
						margin: "0 auto",
						padding: "0 0px",
					}}
				>
					{children}
				</div>
			</Layout.Content>
			<Footer />
		</Layout>
	);
};

export default PageLayout;
